import AppException from "../../app/AppException";
import StringUtil from "../../app/util/StringUtil";
import StvKampagne from "./dto/StvKampagne";
import VermittlerDto from "./dto/VermittlerDto";

class AppInitSingletonBo {
  private _initAppSession = false;

  private _initAppData = false;

  private _uiSessionId?: string;

  private _vermittler?: VermittlerDto;

  private _vertragLaufzeitJahre: number = 0;

  private _partnernrVorh = false;

  private _kampagne?: StvKampagne;

  initAppSession(newUiSessionId?: string) {
    AppException.throwIfTrue(this._initAppSession, () => "initAppSession");

    this._uiSessionId = newUiSessionId;
    this._initAppSession = true;
  }

  initAppData(
    newPartnernrVorh: boolean,
    newlaufzeitJahre: number,
    newVermittler?: VermittlerDto,
    newKampagne?: StvKampagne
  ) {
    AppException.throwIfTrue(this._initAppData, () => "initAppData");

    this._vertragLaufzeitJahre = newlaufzeitJahre;
    this._vermittler = newVermittler;
    this._partnernrVorh = newPartnernrVorh;
    this._initAppData = true;
    this._kampagne = newKampagne;
  }

  isUiSessionIdValid() {
    return !StringUtil.isBlank(this._uiSessionId);
  }

  isPartnernrVorh() {
    return this._partnernrVorh;
  }

  get uiSessionId() {
    return this._uiSessionId;
  }

  get vermittler() {
    return this._vermittler;
  }

  get vertragLaufzeitJahre() {
    return this._vertragLaufzeitJahre;
  }

  get kampagne() {
    return this._kampagne;
  }

  existKampagne() {
    return !!this._kampagne;
  }

  renderAgentur() {
    return (
      !StringUtil.isBlank(this._vermittler?.vmnr) &&
      !StringUtil.isBlank(this._vermittler?.agtName1)
    );
  }
}

// Modul instance (entspricht Singleton)
const bo = new AppInitSingletonBo();
export default bo;
